// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.import__students__container {\r\n    box-shadow: inset 1px 1px 6px;\r\n    overflow: auto;\r\n    max-height: 500px;\r\n    padding: 5px;\n}\n.existed__student {\r\n    border-bottom: 4px solid whitesmoke;\n}\r\n", ""]);
// Exports
module.exports = exports;
